import {
  ownerCreateApi,
  ownerDeleteApi,
  ownerDetailApi,
  ownerEditApi,
  ownerListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { ownerActions } from "./actions";

export function* ownerSaga() {
  yield takeEveryFsa(ownerActions.fetchOwners.started, function* (action) {
    yield* makeAsyncApiCall(action, ownerActions.fetchOwners, ownerListApi);
  });

  yield takeEveryFsa(ownerActions.getOwnerDetails.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      ownerActions.getOwnerDetails,
      ownerDetailApi
    );
  });

  yield takeEveryFsa(ownerActions.createNewOwner.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      ownerActions.createNewOwner,
      ownerCreateApi
    );
  });

  yield takeEveryFsa(ownerActions.updateOwner.started, function* (action) {
    yield* makeAsyncApiCall(action, ownerActions.updateOwner, ownerEditApi);
  });

  yield takeEveryFsa(ownerActions.deleteOwner.started, function* (action) {
    yield* makeAsyncApiCall(action, ownerActions.deleteOwner, ownerDeleteApi);
  });
}
